import { analyticsUrl } from 'utils/wrappers';

import PageableBase, { PAGING_TYPES } from 'app/collections/pageable_base';
import Tracker from 'app/models/tracker';

export default PageableBase.extend({
  model: Tracker,
  key: 'trackers',
  url: analyticsUrl('tracking/v2/trackers/delaying'),
  pagingType: PAGING_TYPES.PER_PAGE,

  initialize(models, {
    dateRange,
    carrierSelection,
    transitDelayAmountSelection,
    deliveryDelayAmountSelection,
    trackerStatusSelection
  }) {
    this.dateRange = dateRange;
    this.carrierSelection = carrierSelection;
    this.transitDelayAmountSelection = transitDelayAmountSelection;
    this.deliveryDelayAmountSelection = deliveryDelayAmountSelection;
    this.trackerStatusSelection = trackerStatusSelection;

    this.listenTo(this.dateRange, 'change', this.resetToFirstPage);
    this.listenTo(this.carrierSelection, 'change', this.resetToFirstPage);
    this.listenTo(this.transitDelayAmountSelection, 'change', this.resetToFirstPage);
    this.listenTo(this.deliveryDelayAmountSelection, 'change', this.resetToFirstPage);
    this.listenTo(this.trackerStatusSelection, 'change', this.resetToFirstPage);
  },

  paramsForFetch() {
    return {
      ...this.dateRange.getParams(),
      ...this.carrierSelection.getParams(),
      ...this.transitDelayAmountSelection.getParams(),
      ...this.deliveryDelayAmountSelection.getParams(),
      ...this.trackerStatusSelection.getParams(),
    };
  },
});



// WEBPACK FOOTER //
// ./app/collections/delayed_trackers.js